import { Paper, Typography } from '@mui/material';
import React from 'react';

export default function DescriptionCard({ description }) {
	return (
		<Paper
			elevation={3}
			sx={{
				width: '100%',
				height: '100%',
				backgroundColor: 'white.main',
				display: 'flex',
				borderRadius: '8px',
				padding: '8px',
			}}
		>
			{description ? (
				<Typography color='' sx={{ overflowWrap: 'anywhere' }}>
					{description}
				</Typography>
			) : (
				<Typography
					sx={{
						margin: '0 auto',
						alignSelf: 'center',
						textAlign: 'center',
					}}
					color='#D9D9D9'
				>
					No hay descripción
				</Typography>
			)}
		</Paper>
	);
}
